import React from "react";
import Popover from "./Popover";
import Recaptcha from 'react-google-invisible-recaptcha';
import LoginService from './LoginService';
import LogoutService from './LogoutService';


export default class PopoverLogin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      recaptchaCode: '',
      usernameError: false,
      passwordError: false,
      apiError: false,
      textApiError: ""
    };

    this.onResolved = this.onResolved.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const name = event.target.name;
    this.setState({[name]: event.target.value, [name+"Error"]: !event.target.checkValidity()});
  }

  handleSubmit(event) {
    event.preventDefault();
    if(event.target.checkValidity()){
      this.recaptcha.execute();
    }else{
      this.recaptcha.reset();
      if(!event.target.username.checkValidity()){
        this.setState({usernameError: true});
      }
      if(!event.target.password.checkValidity()){
        this.setState({passwordError: true});
      }
    }
  }

  onResolved() {
    this.setState({recaptchaCode: this.recaptcha.getResponse()});
    const data = {
      username: this.state.username,
      password: this.state.password,
      recaptchaCode: this.state.recaptchaCode
    };

    const login = new LoginService();
    login.userLogin(data).then((response)=>{
      if(response.error){
        this.recaptcha.reset();
        this.setState({apiError: true, textApiError: response.error});
      } 
    });
  }

  logout(e){
    e.preventDefault();
    const logout = new LogoutService();
    logout.userLogout();
  }

  __handleStateLogin = () => {
    if(localStorage.logged){
      return <div>
        <a href="/user-info/profile?origin=mais" target="_self" className="text-black d-block">Alterar cadastro</a>
        <a href="" target="_self" className="text-black d-block pt-3" onClick={this.logout}>Sair da conta</a>
      </div>;
    }else{
      return <form className="p-2" onSubmit={this.handleSubmit} noValidate>
        <div className="material form-group">
          <div>
            <label className="d-none">E-MAIL ou CPF/CNPJ</label>
            <input type="text" className="form-control border-grey-light" name="username" id="username" placeholder="E-MAIL ou CPF/CNPJ" value={this.state.username} onChange={this.handleChange} required/>
            <span className={this.state.usernameError ? "d-block font-12 mt-1 text-error" : "d-none"}>Preenchimento obrigatório</span>
          </div>
        </div>
        <div className="material form-group">
          <div>
            <label className="d-none">SENHA</label>
            <input type="password" className="form-control border-grey-light" name="password" id="password" placeholder="SENHA" value={this.state.password} onChange={this.handleChange} required/>
            <span className={this.state.passwordError ? "d-block font-12 mt-1 text-error" : "d-none"}>Preenchimento obrigatório</span>
          </div>
        </div>
        <a href="/modal/recovery-password" className="text-loyalty font-12 font-weight-bold float-right mb-3">Esqueci minha senha</a>
        <button type="submit" className="btn btn-block btn-loyalty font-14 font-weight-bold" disabled={this.state.passwordError || this.state.usernameError || this.state.username == '' || this.state.password == ''}>Entrar</button>
        <div className="recaptcha-box mt-3">
          <Recaptcha
            ref={ ref => this.recaptcha = ref }
            sitekey="6LfMQmUUAAAAAHdaklwYpClgahIH78afURdkVZvo"
            onResolved={this.onResolved}
            badge="inline"
            locale="pt-BR"
          />
        </div>
        <div className={this.state.apiError ? "d-block mt-3 text-error font-12" : "d-none"}>{this.state.textApiError}</div>
      </form>;
    }
  };

  render() {
    return (
      <Popover
        className={this.props.className}
        content={this.__handleStateLogin()}>
      </Popover>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/PopoverLogin.js